import { render, staticRenderFns } from "./revenues.vue?vue&type=template&id=535c037e&scoped=true&"
import script from "./revenues.vue?vue&type=script&lang=js&"
export * from "./revenues.vue?vue&type=script&lang=js&"
import style0 from "./revenues.vue?vue&type=style&index=0&id=535c037e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c037e",
  null
  
)

export default component.exports